import { createFileRoute } from "@tanstack/react-router";
import { BookingSearchParams } from "~/features/appointments/schemas";

import AppointmentPage from "~/features/public/pages/appointment";

export const Route = createFileRoute("/(public)/_public/appointments/")({
  component: () => <AppointmentPage />,
  validateSearch: (search: Record<string, unknown>): BookingSearchParams => {
    return {
        slot: search.slot as string | undefined,
        date: search.date as string | undefined,
    };
},
  errorComponent: ({ error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">
          Error Loading Appointment Calender
        </h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});